import { onMounted, ref, type WatchOptions, type WatchSource } from 'vue'

export function useMountedWatch<T extends WatchSource>(
  deps: T | T[],
  callback: (
    newValue?: T[],
    oldValue?: T[],
    OnCleanup?: (cleanupFn: () => void) => void
  ) => void,
  options?: WatchOptions
) {
  const init = ref(false)

  onMounted(() => {
    init.value = true
  })

  const _deps = Array.isArray(deps)
    ? [() => init.value, ...deps]
    : [() => init.value, deps]

  watch(
    _deps,
    (newValue, oldValue, onCleanup) => {
      // 确保在组件挂载后执行
      const [_newInit, ...newVal] = newValue as T[]
      const [_oldInit, ...oldVal] = oldValue as T[]
      if (_newInit) {
        callback(newVal, oldVal, onCleanup)
      }
    },
    options
  )
}
